import React, { useEffect, useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp, faEdit, faList } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button, ListGroup, ListGroupItem, FormGroup, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { api, globalErrorHandler } from '../api/create-api.js';
import { AppName } from '../App.js';
import { makeCall } from '../auth-utils.js';
import Can from './Shared/Can.js';
import { Title } from './Title.js';
import { AssetList } from './Assets/AssetList.js';
import { List } from './LeaseDetails/List.js';
import { SearchBar } from '@galop/component-library';
import { Settings } from './Shared/Settings.js';
import Lock, { AppIsLocked } from './Shared/Lock.js';

export const Home = (props) => {
    const { addToast } = useToasts();
    const ls = require('local-storage');
    const { Access, LoginMessage, CurrentUser } = props;
    const [redirect, setRedirect] = useState('');
    const [assets, setAssets] = useState(null);
    const [questions, setQuestions] = useState([]);
    const [policies, setPolicies] = useState([]);
    const [selectedAsset, setSelectedAsset] = useState(props.selectedAsset || ls('selected-asset'));
    const [editAsset, setEditAsset] = useState();
    const [editing, setEditing] = useState(false);
    const [filteredAsset, setFilteredAsset] = useState('');
    const [filteredAssets, setFilteredAssets] = useState(null);

    const config = {
        resourceName: 'asset',
        capitalResourceName: 'Asset',
        pluralResourceName: function () {
            return this.resourceName + 's';
        },
        pluralCapitalResourceName: function () {
            return this.capitalResourceName + 's';
        },
        writeRole: "admin",
        showHelp: false,
        controllerName: 'assets',
        localStorage: 'selected-asset'
    };

    useEffect(() => getQuestions(), []);

    //useEffect(() => getAssets(false), [CurrentUser]);

    useEffect(() => FilterAssets(assets), [filteredAsset]);

    useEffect(() => {
        if (!props.selectedAsset) {
            getAssets(false, (assets) => {
                if ((assets && assets.length > 0) && ((!(ls('selected-asset')) || ls('selected-asset') === {}) || !assets.map(asset => asset.id).includes((selectedAsset || {}).id))) {
                    setSelectedAsset(assets[0]);
                }
            });
        }
        else {
            setSelectedAsset(props.selectedAsset);
        }
    }, [CurrentUser]);

    const ChangeProperty = (value) => {
        if (assets && assets.length > 0) {
            const selected = assets.filter(asset => asset.id === value)[0];
            if (selected) {
                setFilteredAsset('');
                setSelectedAsset(selected);
            }
        }
    };

    const getAssets = (loadFullObjects, callback) => {
        if (CurrentUser) {
            makeCall(async (authHeader) => {
                const result = await api(`api/assets/${CurrentUser.id}?loadFullObject=${loadFullObjects}`, { headers: authHeader })
                    .catch(error => globalErrorHandler(error, addToast));

                if (result) {
                    if (result.status === 204) {
                        setAssets(null);
                    }
                    else if (result.data) {
                        if (!loadFullObjects && result.data.length > 15) {
                            getAssets(true);
                        }
                        setAssets(result.data);
                        FilterAssets(result.data);

                        if (callback && typeof callback === 'function') {
                            callback(result.data);
                        }
                    }
                }
            });
        }
    };

    const FilterAssets = (unfiltered) => {
        let filteredList = [];

        if (filteredAsset !== "") {
            filteredList = unfiltered.filter(resource => {
                const lcFilter = filteredAsset.toLowerCase();

                // Search by table columns
                const name = (resource.name || '').toLowerCase(); // Name
                const assetName = (resource.assetName || '').toLowerCase(); // Name


                return name.includes(lcFilter)
                    || assetName.includes(lcFilter);
            });
        }
        else {
            filteredList = unfiltered;
        }

        setFilteredAssets(filteredList);
    };

    const getQuestions = () => {
        makeCall(async (authHeader) => {
            const questionsResult = await api(`api/assets/questions`, { headers: authHeader })
                .catch(error => globalErrorHandler(error, addToast));

            if (questionsResult && questionsResult.data) {
                setQuestions(questionsResult.data);
            }
        });
    };

    return (
        <div className="d-flex flex-column h-100">
            <Title subtitle="Home" />
            {redirect ? <Redirect to={redirect} /> : null}
            <Row>
                <Col lg="8" className=" text-center text-md-left">
                    <div className="border-secondary pb-0 mb-2" style={{ borderBottomWidth: 2, borderBottomStyle: 'solid' }}>
                        <h2>
                            <div className="d-flex flex-column flex-md-row">
                                <div>
                                    {AppName}
                                </div>
                                <Can role="user"
                                    yes={() =>
                                        <div className="text-dark flex-fill ml-2">
                                            {(selectedAsset || {}).name}
                                            {filteredAssets && assets && assets.length > 1 && (<UncontrolledDropdown className="d-inline-block">
                                                <DropdownToggle size="sm" color="light" className="border ml-1" disabled={editAsset || editing}><FontAwesomeIcon icon={faCaretDown} /></DropdownToggle>
                                                <DropdownMenu right className="shadow">
                                                    {assets && assets.length > 12 &&
                                                        <div className="px-2">
                                                            <SearchBar value={filteredAsset} onChange={(value) => setFilteredAsset(value)} placeHolder="Search Assets" Reset={() => setFilteredAsset('')} />
                                                        </div>
                                                    }
                                                    <div style={assets && assets.length > 12 ? { maxHeight: 280, overflow: 'scroll' } : null}>
                                                        {filteredAsset && filteredAssets.length > 0 && <DropdownItem divider />}
                                                        {filteredAsset && filteredAssets.length > 0 && <DropdownItem header>Search Results</DropdownItem>}
                                                        {filteredAsset && filteredAssets.slice(0, 5).map(asset => <DropdownItem key={asset.id} active={asset.id === (selectedAsset || {}).id} onClick={() => ChangeProperty(asset.id)}>{asset.name}</DropdownItem>)}
                                                        {assets && assets.length > 12 && <DropdownItem divider />}
                                                        {assets.map(asset => <DropdownItem key={asset.id} active={asset.id === (selectedAsset || {}).id} onClick={() => ChangeProperty(asset.id)}>{asset.name}</DropdownItem>)}
                                                    </div>
                                                </DropdownMenu>
                                            </UncontrolledDropdown>)}
                                            {selectedAsset &&
                                                <Lock
                                                    locked={() =>
                                                        <Button color="link" size="sm" className={`text-secondary ${editAsset || editing ? 'd-none' : 'd-inline'}`} onClick={() => setEditAsset(!editAsset)}><FontAwesomeIcon icon={faList} /> View</Button>
                                                    }
                                                    unlocked={() =>
                                                        <Button color="link" size="sm" className={`text-secondary ${editAsset || editing ? 'd-none' : 'd-inline'}`} onClick={() => setEditAsset(!editAsset)}><FontAwesomeIcon icon={faEdit} /> Edit</Button>
                                                    }
                                                />
                                            }
                                        </div>
                                    }
                                />
                            </div>
                        </h2>
                    </div>
                </Col>
            </Row>
            <Row className="h-75 flex-fill">
                <Can role="admin"
                    yes={() =>
                        <Col sm="6" md="3">
                            <fieldset className="mb-2">
                                <legend>Manage</legend>
                                <ListGroup>
                                    <ListGroupItem tag={Link} to="/assets" action>Assets</ListGroupItem>
                                    <ListGroupItem tag={Link} to="/users" action>Users</ListGroupItem>
                                </ListGroup>
                            </fieldset>
                            <fieldset>
                                <legend>View</legend>
                                <ListGroup>
                                    <ListGroupItem tag={Link} to="/reports" action>Reports</ListGroupItem>
                                </ListGroup>
                            </fieldset>
                        </Col>
                    }
                />
                <Can role="admin"
                    yes={() =>
                        <Col sm="6">
                            <Settings />
                        </Col>
                    }
                />
                <Can role="user"
                    yes={() =>
                        <Col className="h-100">
                            <List {...{ assets, editAsset, setEditAsset, editing, setEditing, selectedAsset, questions, policies, userId: (CurrentUser || {}).id }} />
                        </Col>
                    }
                />
            </Row>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/Home.js